<template lang="html">
  <footer id="footer">
    <div class="container oversized-container">

      <div class="row align-items-center row-top">
        <div class="col-lg-5 col-left col-newsletter">
          <b-form @submit="onSubmit">
            <b-form-input
              v-model="form.email"
              type="email"
              placeholder="Escribe tu correo..."
              required
            ></b-form-input>

            <b-button type="submit" class="btn-submit">Inscribirse</b-button>
          </b-form>
        </div>

        <div class="col-lg col-middle">
          <h6>Sé el primero en enterarte</h6>
          <h4>Regístrate a nuestro newsletter</h4>
        </div>

        <div class="col-lg row mx-0 col-right">
          <router-link class="logo" to="/"><img src="public/images/logo.png"></router-link>
        </div>
      </div>

      <div class="row row-bottom">
        <div class="col-sm-6 col-lg-3 col-middle align-self-center">
          <div class="box-networks">
            <a class="t-150 btn-network fb" target="_blank" href="https://www.facebook.com/mi15anos"><i class="fab fa-facebook-f"></i></a>
            <a class="t-150 btn-network tw" target="_blank" href="https://twitter.com/QuinceaneraSho1"><i class="fab fa-twitter"></i></a>
            <a class="t-150 btn-network ig" target="_blank" href="https://www.instagram.com/quinceanerashopping/"><i class="fab fa-instagram"></i></a>
            <a class="t-150 btn-network lk" target="_blank" href="https://www.pinterest.com/QuinceaneraShopping"><i class="fa-brands fa-pinterest-p"></i></a>
            <!-- <a class="t-150 btn-network lk" href="#"><i class="fab fa-linkedin-in"></i></a> -->
          </div>

          <p class="my-1">
            <router-link to="/aviso-de-privacidad">Aviso de privacidad</router-link>
          </p>
          <!-- <p class="my-1">
            <router-link to="/politicas-de-ventas">Políticas de Ventas</router-link>
          </p> -->
          <p class="my-1">
            <router-link to="/terminos-y-condiciones">Términos y condiciones</router-link>
          </p>
          <p class="my-1">
            <span>Derechos Reservados XV Shopping {{ currentYear }}</span>
          </p>
          <!-- <p class="my-2">
            <span><i class="icon"><i class="far fa-envelope"></i></i> contacto@quinceanerashopping.com</span>
          </p> -->
        </div>

        <div class="col-lg-5 col-xl-6 col-menus">
          <div class="row">
            <div class="col-6 col-sm-6 col-menu">
              <h6 class="title">Mapa del sitio</h6>

              <p class="my-1">
                <router-link to="/">Inicio</router-link>
              </p>
              <p class="my-1">
                <router-link to="/productos">Catálogo</router-link>
              </p>
              <p class="my-1">
                <router-link to="/promociones">Promociones</router-link>
              </p>
            </div>

            <div class="col-6 col-sm-6 col-menu">
              <h6 class="title">Información</h6>

              <p class="my-1">
                <router-link to="/nosotros">Nosotros</router-link>
              </p>
              <p class="my-1">
                <router-link to="/blog">Blog</router-link>
              </p>
              <p class="my-1">
                <router-link to="/contacto">Contacto</router-link>
              </p>
            </div>

            <!-- <div class="col-6 col-sm-4 col-menu">
              <h6 class="title">Links de acceso</h6>

              <p class="my-1">
                <router-link to="/registrarse">Registrate</router-link>
              </p>
              <p class="my-1">
                <router-link to="/login">Inicia sesión</router-link>
              </p>
              <p class="my-1">
                <router-link to="/recuperar-contrasena">Recuperar contraseña</router-link>
              </p>
            </div> -->
          </div>
        </div>

        <div class="col-sm-6 col-lg-4 col-xl-3 col-info">
          <h6 class="c-title">Contáctanos</h6>
          <p>
            <span class="p-icon icon-email">info@quinceanerashopping.com</span>
          </p>
          <p class="mt-3">
            <span class="p-icon icon-phone">Tel. 21 4414 7613</span>
          </p>
          <p class="mt-3">
            <!-- <a class="p-icon icon-location"></a> -->
            <span class="p-icon icon-location">Calle No. X, Ciudad, TX, USA.</span>
          </p>
        </div>
      </div>

    </div>
  </footer>
</template>

<script>
export default {
  data(){
    return{
      currentYear: 0,

      form: {
        email: null
      },
      info: {
        email:null,
        contact:null,
        address:null,
      },
    }
  },

  methods:{

    makeToast(variant = null, msg, title) {
      this.$bvToast.toast(msg, {
        title: title,
        variant: variant,
        solid: true,
        toaster: 'b-toaster-top-right',
        appendToast: true
      });
    },

    onSubmit(evt) {
      evt.preventDefault();
      var r = confirm("¿Deseas regístrate en newsletter? ");
      if (r == true) {
        axios.post(tools.url("/api/newsletter"), this.form).then((response)=>{
          this.makeToast('default', response.data.response, 'Correo registrado');
          this.form = {
            name: null,
            email: null,
            msg: null,
            check: null
          };
        }).catch( (error)=> {
          // console.log(error.response);
          let errors = error.response.data;
          // console.log(errors);
          this.makeToast('danger', error.response.data.name, 'Error');
          this.makeToast('danger', error.response.data.email, 'Error');
          this.makeToast('danger', error.response.data.phone, 'Error');
          this.makeToast('danger', error.response.data.msg, 'Error');
        });
      }
    },
    getInfo: function(){
      axios.get(tools.url('/api/info')).then((response)=>{
        this.info = response.data;
      }).catch((error)=>{
        console.log(error);
      })
    },
  },

  beforeMount(){
    this.currentYear = new Date().getFullYear();
    // this.getInfo();
  }
}
</script>
